module.exports = __webpack_public_path__ + "static/mock-up_stay-85244220cafc4f61cce69b3690b4e478.png";